
import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  layoutSettings: { fullWidth: true },

  data: () => ({
    title: "РИФ.Фестиваль",
    isMounted: false,
  }),

  head () {
    return { title: this.getTitle(this.title) }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },

  mounted () {
    this.isMounted = true
  },
})
